import React from "react";

export default function LayoutIcon({ color = "currentColor" }) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 36 36"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0715 3.2168H3.85721C3.50364 3.2168 3.21436 3.50608 3.21436 3.85965V16.0739C3.21436 16.4275 3.50364 16.7168 3.85721 16.7168H16.0715C16.4251 16.7168 16.7144 16.4275 16.7144 16.0739V3.85965C16.7144 3.50608 16.4251 3.2168 16.0715 3.2168ZM13.9822 13.9847H5.9465V5.94894H13.9822V13.9847ZM32.1429 3.2168H19.9286C19.5751 3.2168 19.2858 3.50608 19.2858 3.85965V16.0739C19.2858 16.4275 19.5751 16.7168 19.9286 16.7168H32.1429C32.4965 16.7168 32.7858 16.4275 32.7858 16.0739V3.85965C32.7858 3.50608 32.4965 3.2168 32.1429 3.2168ZM30.0536 13.9847H22.0179V5.94894H30.0536V13.9847ZM16.0715 19.2882H3.85721C3.50364 19.2882 3.21436 19.5775 3.21436 19.9311V32.1454C3.21436 32.4989 3.50364 32.7882 3.85721 32.7882H16.0715C16.4251 32.7882 16.7144 32.4989 16.7144 32.1454V19.9311C16.7144 19.5775 16.4251 19.2882 16.0715 19.2882ZM13.9822 30.0561H5.9465V22.0204H13.9822V30.0561ZM32.1429 19.2882H19.9286C19.5751 19.2882 19.2858 19.5775 19.2858 19.9311V32.1454C19.2858 32.4989 19.5751 32.7882 19.9286 32.7882H32.1429C32.4965 32.7882 32.7858 32.4989 32.7858 32.1454V19.9311C32.7858 19.5775 32.4965 19.2882 32.1429 19.2882ZM30.0536 30.0561H22.0179V22.0204H30.0536V30.0561Z"
        fill="#fff"
        fillOpacity="0.85"
      />
    </svg>
  );
}
